



























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class CodeButton extends Vue {
    @Prop() private userConfigColor! : string;

    setIsSelectCodeVisible(){
        this.$emit("setIsSelectCodeVisible");
    }
}
